import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=c2107b66&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"
import style0 from "./signUp.vue?vue&type=style&index=0&id=c2107b66&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./signUp.vue?vue&type=style&index=1&id=c2107b66&prod&lang=scss"
import style2 from "./signUp.vue?vue&type=style&index=2&id=c2107b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2107b66",
  null
  
)

export default component.exports